import { createFileRoute } from "@tanstack/react-router";
import EditorialProcess from "@/pages/EditorialProcess";

export const Route = createFileRoute("/processo-editorial")({
  component: EditorialProcess,
});